import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import VerifyEmail from "./components/pages/VerifyEmail";
import Home from "./components/pages/index";
import Profile from "./components/pages/Profile";
import Layout from "./components/Layout";
import PrivateRoute from "./routes/PrivateRoutes";
import Apropos from "./components/Apropos/Apropos";
import Thanks from "./components/pages/Thanks";
import News from "./components/pages/News";
import MesDocuments from "./components/pages/MesDocuments";
import AnalyticsTracker from "./AnalyticsTracker";
import Post from "./components/pages/Post.jsx";
import Avis from "./components/pages/Avis";

import ForgotPasswordClient from "./pages/ForgotPasswordClient";
import ForgotPasswordDriver from "./pages/ForgotPasswordDriver";
import ResetPasswordClient from "./pages/ResetPasswordClient";
import ResetPasswordDriver from "./pages/ResetPasswordDriver";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsTracker />

        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />

            <Route path="Apropos" element={<Apropos />} />
            <Route path="thanks" element={<Thanks />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="post/:id" element={<Post />} />
            <Route path="avis" element={<Avis />} />

            {/* Politique de confidentialité */}
            <Route
              path="politique-de-confidentialite"
              element={<PrivacyPolicy />}
            />

            {/* Mot de passe */}
            <Route
              path="forgot-password/client"
              element={<ForgotPasswordClient />}
            />
            <Route
              path="forgot-password/driver"
              element={<ForgotPasswordDriver />}
            />
            <Route
              path="reset-password/client"
              element={<ResetPasswordClient />}
            />
            <Route
              path="reset-password/driver"
              element={<ResetPasswordDriver />}
            />

            {/* Routes protégées */}
            <Route
              path="profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />

            <Route
              path="news"
              element={
                <PrivateRoute>
                  <News />
                </PrivateRoute>
              }
            />

            <Route
              path="mes-documents"
              element={
                <PrivateRoute>
                  <MesDocuments />
                </PrivateRoute>
              }
            />

            {/* Route inconnue → accueil */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;